import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../../components/feature/TrustBar';
import ServicesGrid from '../../components/feature/ServicesGrid';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import BenefitsSection from '../../components/feature/BenefitsSection';
import ProcessSection from '../../components/feature/ProcessSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import CTASection from '../../components/feature/CTASection';
import ContactSection from '../../components/feature/ContactSection';
import MapSection from '../../components/feature/MapSection';

export default function Services() {
  return (
    <div className="min-h-screen bg-white pb-16 lg:pb-0">
      <Navbar />

      {/* Hero */}
      <section className="relative min-h-screen flex items-center justify-center">
        <div className="absolute inset-0">
          <img src="https://public.readdy.ai/ai/img_res/7058dc36e1fe2064743f43c6d77a626a.jpg" alt="A Better Alternative Medical Center services programs Hackensack NJ" className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(105deg, rgba(5,30,25,0.93) 0%, rgba(10,60,48,0.80) 45%, rgba(10,60,48,0.30) 100%)' }}></div>
        </div>
        <div className="relative z-10 w-full px-6 lg:px-12 pt-24">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-5">
              <span className="inline-block w-8 h-px bg-amber-400"></span>
              <p className="text-amber-400 text-xs font-bold tracking-widest uppercase">12 Specialized Programs · Hackensack, NJ</p>
            </div>
            <h1 className="font-heading text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Functional Medicine Services<br />That Get Real Results
            </h1>
            <p className="text-teal-100 text-xl mb-8 leading-relaxed">Root-cause programs for hormones, thyroid, IV chelation, mental health, weight management, and complete whole-person healing — backed by 40+ years of clinical expertise.</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="tel:2015251155" className="flex items-center justify-center gap-2 bg-white text-teal-900 px-7 py-3.5 rounded-md text-sm font-semibold hover:bg-amber-50 transition-colors cursor-pointer whitespace-nowrap">
                <div className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-fill text-teal-700 text-base"></i></div>
                Call (201) 525-1155
              </a>
              <Link to="/contact" className="flex items-center justify-center gap-2 border-2 border-white text-white px-7 py-3.5 rounded-md text-sm font-semibold hover:bg-white hover:text-teal-900 transition-colors cursor-pointer whitespace-nowrap">
                Discuss Your Needs
              </Link>
            </div>
          </div>
        </div>
      </section>

      <TrustBar />
      <ServicesGrid />
      <AIAnswerBlock page="services" />
      <BenefitsSection />
      <CTASection variant="mid" />
      <ProcessSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection variant="bottom" />
      <ContactSection />
      <MapSection />
      <Footer />
    </div>
  );
}
